import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';

export function useATVLandingPageExp() {
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_ATV_LANDING_PAGE');
	const { country } = storeToRefs(useLanguageStore());

	function setATVLandingPageTags(url: ClickoutUrl, shortName: string, inPromotionCatalogue: boolean) {
		if (!variant.value || inPromotionCatalogue || shortName !== 'atp') return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: country.value,
			placement: 'ft',
			providerShortName: shortName,
		});

		if (variant.value === 'variant_1') url.set('uct_ctag2', 'atvlpg:v1');

		return url.set('uct_ctag', tag);
	}

	return {
		setATVLandingPageTags,
	};
}
